<style lang="scss">

    $primary: #FFFFFF;

    .navbar-toggler{

        span.hamburger-box{
            transition: all 200ms;
            opacity:.7;
            position: relative;
            width: 40px;
            height: 40px;
            border: 1px solid rgba(255, 255, 255, 0.7);
            border-radius: 100px;

            @media (max-width: 575px) {
                width: 35px;
                height: 35px;
            }

        }

    }

    @media (min-width: 1200px) {

        .navbar-toggler{

            .hamburger-inner{
                transition: all 200ms;

                &:before, &:after{
                    transition: all 200ms;
                }

            }

            &:hover{

                .hamburger-box{
                    transition: all 200ms;
                    opacity: 1;

                    .hamburger-inner{
                        background-color:$primary;
                        transition: all 200ms;

                        &:before, &:after{
                            background-color:$primary;
                            transition: all 200ms;
                        }
                    }

                }

                span{
                    color: $primary;
                    transition: all 200ms;
                    mix-blend-mode: unset !important;
                }
            }

        }

    }

</style>

<template>
    <button @click="manageHamburger" class="navbar-toggler hamburger hamburger--spin hamburger--collapse position-relative d-flex align-items-center ms-25 ms-sm-4 ms-md-4 text-primary-hover h7" :class="'theme-' + theme" type="button" aria-expanded="false" aria-label="Toggle navigation">
        <span class="hamburger-box" :class="{'hamburger-box--close' : open}">
            <span class="hamburger-inner"></span>
        </span>
        <span class="text-white ms-25 hamburger-label font-alternate h7">
            <span class="text-smaller-85 text-smaller-sm-95">MENU</span>
        </span>
    </button>
</template>
<script>

export default {
    props: ['themeProp'],
    data: function () {
        return {
            open:false,
            theme: this.themeProp,
            separated_colors: false,
            menu_open: false,
        };
    },
    mounted() {

        this.$eventHub.$on('menuIsOpen', (payload) => {
            if(payload.open) {
                this.menu_open = true;
                return
            }
            this.menu_open = false;
        });

        this.$eventHub.$on('closeMenu', (payload) => {
            this.manageHamburger();
        });

        window.addEventListener('resize', () => {

            document.querySelector('.navbar-collapse').style = "";
            if(this.open){
                this.open = false;
                this.manageHamburger();
            }

        });
    },
    methods: {
        findBreakpointTheme() {
            let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            let res = null;
            let themes = this.themeProp.split('-');
            if (vw < 576){
                res = 0;
            }else if (vw >= 576 && vw < 768) {
                res = 1;
            }else if (vw >= 768 && vw < 992) {
                res = 2;
            }else if (vw >= 992 && vw < 1199) {
                res = 3;
            }else if (vw >= 1200) {
                res = 4;
            }
            return themes[res];
        },
        manageHamburger() {

            let tl = gsap.timeline({});
            let hamburger =  document.querySelector('.hamburger');
            let collapse = document.querySelector('.navbar-collapse');
            let navbar = document.querySelector('nav.navbar');

            navbar.setAttribute('data-open', this.open);

            if(!this.open) {

                if(window.vw > 1199) {
                    try{
                        bodyScrollBar.scrollTo(0, 0, 300);
                    }catch(err){}
                }else{
                    window.scrollTo(0, 0);
                    document.querySelector('body').classList.add('position-fixed');
                }

                window.stop_scroll = true;

                //triggers change in other components
                this.$eventHub.$emit('menuIsOpen', {'open':true, 'mobile':(window.vw <= 767 ? true : false)});
                //turn hamburger into an X
                hamburger.classList.add('is-active');

                let elems = document.querySelectorAll('.menu-animate')
                gsap.fromTo(elems, {autoAlpha: 0, x: -30}, {duration: .6, delay: .4, force3D:true, ease: 'Power1.easeInOut', autoAlpha:1, x: 0, stagger: 0.05,}, "-=0");

                //case slides from side
                //collapse opens
                tl.to(collapse, {duration: .9, delay: 0, left: "0", force3D: true, ease: 'Power4.easeOut',
                    onComplete:() => {
                        requestAnimationFrame(() => {

                        })
                    }
                });
                tl.call(function() {
                }, null, "-=.6");

            }else{

                window.stop_scroll = false;
                document.querySelector('body').classList.remove('position-fixed');

                hamburger.classList.remove('is-active');

                //triggers change in other components
                this.$eventHub.$emit('menuIsOpen', {'open':false, 'mobile':(window.vw <= 767 ? true : false)});
                let elems = document.querySelectorAll('.menu-animate');
                tl.to(elems, {duration: .3, delay: 0, force3D:true, ease: 'Power1.easeInOut', autoAlpha:0, x: -20, stagger: 0,}, "-=0");

                //slides back to left
                //the language bordered block turns darker instantly

                tl.to(collapse, {duration: 1.5, delay: 0, left:"-100vw", force3D:true, ease: 'Power4.easeOut',
                    onComplete:() => {
                        requestAnimationFrame(() => {})
                    }
                },"-=.3");
                //slides from side
                tl.call(function() {
                    hamburger.classList.remove('is-active');
                }, null, "-=.55");
            }

            this.open = !this.open
        }
    },
    beforeDestroy() {
        this.$eventHub.$off('menuIsOpen');
        this.$eventHub.$off('closeMenu');
    }
}
</script>
